//@ts-nocheck
import { addResizeListener, isPad } from "./tools";

export default function adaptPad() {
  const adapt = () => {
    const _meta = document.querySelector("#pad");
    if (isPad()) {
      document.querySelector("html").style.fontSize = "5vw";
      const head = document.getElementsByTagName("head");
      const meta = document.createElement("meta");
      meta.id = "pad";
      meta.name = "viewport";
      meta.content =
        "target-densitydpi=device-dpi, width=750px, user-scalable=no";
      if (!_meta) {
        head.length > 0 && head[head.length - 1].appendChild(meta);
      }
    } else {
      _meta?.remove();
    }
  };

  let timer = null;
  clearInterval(timer);
  timer = setInterval(() => {
    const head = document.getElementsByTagName("head");
    if (head) {
      clearInterval(timer);
      adapt();
    }
  }, 1000);

  addResizeListener(adapt, false);
}
